import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";
import { Job } from "../data/api";

const jobsAPI = createApi({
    reducerPath: "jobsAPI",
    baseQuery: fetchBaseQueryCSRF({
        baseUrl: process.env.CROSS_API_URL + "/jobs",
    }),
    endpoints: (builder) => ({
        getJobs: builder.query<{jobs: Job[]}, void>({
            query: () => ({
                url: "/",
            }),
        }),
    }),
});

export default jobsAPI;

export const { useGetJobsQuery } = jobsAPI;